<template>
    <div>
        <v-card>
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="quoteData.items"
                    hide-actions
                    >
                    <template slot="items" slot-scope="props">
                        <td>
                            <!-- {{props.item.seqNo}} -->
                            <v-btn
                                small
                                icon
                                :disabled="props.index === 0"
                                @click="$emit('onMoveItem', props.item, true)"
                                v-show="canAddDeleteItem"
                                >
                                <v-icon color="primary" >arrow_circle_up</v-icon>
                                </v-btn>

                                <!-- Move Down Button -->
                                <v-btn
                                small
                                icon
                                
                                :disabled="props.index === quoteData.items.length - 1"
                                @click="$emit('onMoveItem', props.item, false)"
                                v-show="canAddDeleteItem"
                                >
                                <v-icon color="primary" >
                                    arrow_circle_down
                                </v-icon>
                                </v-btn>
                        </td>
                      <td class="py-1 px-1">
                          <v-img
                              :src="props.item.imgThumbnailUrl"
                              width="120"
                              aspect-ratio="1.5"
                              contain
                          >
                                <v-layout column fill-height class=" ">
                                    <v-spacer></v-spacer>
                                    <v-flex shrink pb-2>
                                        <div class="text-xs-center" v-if="!props.item.itemId">
                                            <v-btn small color="info" @click="$emit('onUploadItemImage', props.item)" >Upload Image</v-btn>
                                        </div>
                                    </v-flex>
                                </v-layout>
                          </v-img>
<!-- <v-img src="https://healthmark.canto.com/preview/image/ncaoljr3455v36q3ibqiir1c1h/640"
    height="80"
    width="120"
>
</v-img> -->
                      </td>

                      <!-- <td class="px-1 text-no-wrap">{{ props.item.itemNumber }}</td> -->
                      <td class="px-1 text-no-wrap">{{ props.item.catalogNum }}</td>
                      <td class="px-1">{{ props.item.description }}</td>
                      <td class="px-1 text-xs-center text-no-wrap">{{ props.item.unit }}</td>
                      <td class="px-1 text-xs-center">{{ props.item.qty }}</td>
                      <td class="px-1 text-xs-right">
                          <!-- {{ !props.item.unitPrice? "0.00" : props.item.unitPrice | toCurrency }} -->
                          {{ formatCurrency((!props.item.unitPrice? 0 : props.item.unitPrice), props.item.currnIdx) }}
                          <div>
                              {{ props.item.unitPricePriceLevel? `(${props.item.unitPricePriceLevel})` : "" }}
                          </div>
                      </td>
                      <!-- <td class="px-1 text-xs-right"></td> -->
                      <!-- <td class="px-1 text-xs-right">{{ props.item.discountPct? (props.item.discountPct + '%') :'n/a' }}</td> -->
                      <td class="px-1 text-xs-right">
                          <!-- {{ !props.item.totalPrice? "$0.00" : props.item.totalPrice | toCurrency }} -->
                          {{ formatCurrency((!props.item.totalPrice? 0 : props.item.totalPrice), props.item.currnIdx) }}
                            <div class="body-1">
                            {{ getItemPromotionOrDiscountSummary(props.item) }}
                            </div>
                            <div class="body-1 warning--text">
                            {{ inPromotionMsg(props.item) }}
                            </div>
                      </td>

                        <td>
                            <div>{{props.item.notes}}</div>
                            <div v-if="props.item.systemNotes && !(props.item.unitPrice > 0)" class="caption error--text" style="white-space: normal;">
                                {{props.item.systemNotes}}
                            </div>
                        </td>
                        <td>
                            <v-btn small color="primary" 
                                v-show="canEditItem" @click.prevent="$emit('onEditItem', props.item)" >Edit</v-btn>
                            <v-btn small color="primary" 
                                v-show="canAddDeleteItem" @click.prevent="$emit('onDeleteItem', props.item)" >Delete</v-btn>
                        </td>
                    </template>
                </v-data-table>

            </v-card-text>
        </v-card>

    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ctlQuoteItemEdit from '@/components/public/ctlQuoteItemEdit'
export default {
    props: ['quoteData'],
    components: {
        ctlQuoteItemEdit
    },
    data() {
        return {
            showItemEditPopup: false,
            itemEditing: null,
            headers: [
                { text: '', sortable: false},
                { text: '', sortable: false},
                { text: 'CATALOG #', sortable: false},
                { text: 'DESCRIPTION' , sortable: false},
                { text: 'UNIT' , sortable: false},
                { text: 'QTY', sortable: false, class: ['px-1']},
                { text: 'RATE' , sortable: false, align: 'center'},
                // { text: 'PRICE LEVEL' , sortable: false},
                // { text: 'DISCOUNT' , sortable: false},
                { text: 'TOTAL' , sortable: false, align: 'right'},
                { text: 'Internal Notes', value: 'notes', sortable: false, class: ['px-1']},
                { text: '', sortable: false}
            ],
        }
    },
    computed: {
        ...mapGetters('auth', [
            'userHasInternalRole',
            'userHasSalesRepRole',
            'userHasSalesQuoteManagerRole',
        ]),
        quoteItemsActiveOnly () {
            return this.quoteData.items.filter(p=>p.active)
        },
        canEditItem () {
            return (this.userHasInternalRole || this.userHasSalesQuoteManagerRole) 
                && this.quoteData.basicInfo.statusId != 'SentToCustomer'
                && this.quoteData.basicInfo.statusId != 'Won'
                && this.quoteData.basicInfo.statusId != 'Lost'
        },
        canAddDeleteItem () {
            return this.quoteData.basicInfo.statusId != 'SentToCustomer'
                && this.quoteData.basicInfo.statusId != 'Won'
                && this.quoteData.basicInfo.statusId != 'Lost'
        },
    },
    methods: {

        addNewItem() {
            // to new item, populate init data here
            this.itemEditing = {
                id : null,
                itemId : null,
                itemNumber : null,
                description : null,
                qty : null,
                active : true,
                notes : null,
            }
            this.showItemEditPopup = true
        },
        editItem(item) {
            this.itemEditing = item
            this.showItemEditPopup = true
        },
        deleteItem(item) {
            if(item.id) {
                // existed item in db, set to inactive
                item.active = false
            } else {
                this.quoteData.items = this.quoteData.items.filter(p=> p != item)
            }
        },
        onSaveItem(newOrExistedItem) {
            this.showItemEditPopup = false

            if (newOrExistedItem) {
                // if(newOrExistedItem.id) {
                //     var existedItem = this.quoteData.items.find(o=>o.id === newOrExistedItem.id)
                //     existedItem = Object.assign({}, existedItem, newOrExistedItem)
                // }else {
                //     }
                var foundItem = this.quoteData.items.find(o=>o.itemNumber === newOrExistedItem.itemNumber)
                if (!foundItem) {
                    this.quoteData.items = [...this.quoteData.items, newOrExistedItem]
                } else {
                    foundItem = Object.assign({}, foundItem, newOrExistedItem)
                }
            }
        },
        getItemPromotionOrDiscountSummary(itemData) {
            let discountApprovalMsg = '';
            const promotion = itemData.promotionApplied
            if(itemData.approvalStatus) {
                discountApprovalMsg = ' ' + itemData.approvalStatus
            }            
            
            if(!promotion) {
                return itemData.discountPct? `(Discount: ${itemData.discountPct}%${discountApprovalMsg})` :''
            }
            
            //has promotion
            if (promotion.promotionType === "DiscountPct") {
                return `(Promotion Discount: ${promotion.promotionAmt}%${discountApprovalMsg})`;
            } else if (promotion.promotionType === "PromotionPrice"){
                return `(Promotion Unit Price: $${promotion.promotionAmt}${discountApprovalMsg})`;
            } else if (promotion.promotionType === "BuyXGetYFree"){
                return `(Promotion: Buy ${promotion.buyXGetYFreeBuyQty} Get ${promotion.buyXGetYFreeGetQty} Free${discountApprovalMsg})`;
            }
            // else {
            //     return `(Promotion Unit Price: $${promotion.promotionAmt} ${discountApprovalMsg})`;
            // }

        },
        inPromotionMsg(itemData) {
            if(itemData.promotions && itemData.promotions.length > 0 && !itemData.promotionApplied) {
                return `(In Promotion)`
            }
            
        },
        // moveItem(itemData, isMoveUp) {
        //     // const index = this.quoteData.items.findIndex(item => item.id === id);

        //     // if (index === -1) return;

        //     // const targetIndex = isMoveUp ? index - 1 : index + 1;

        //     // if (targetIndex < 0 || targetIndex >= this.quoteData.items.length) return;

        //     // // Swap items in the array
        //     // const temp = this.quoteData.items[index];
        //     // this.quoteData.items[index] = this.quoteData.items[targetIndex];
        //     // this.quoteData.items[targetIndex] = temp;

        //     // // Update SeqNo
        //     // this.quoteData.items.forEach((item, idx) => {
        //     //     item.seqNo = idx + 1;
        //     // });
        //     const seqCode = isMoveUp? -999 : 999;
        //     const movedItem = Object.assign({}, itemData, {seqNo: seqCode})
            

        // },
    }
}
</script>
